import type { IStepperBuild, IStepperConfig } from './types';

import { merge } from '../../helper';

import isEmptyArray from '../../general/isEmpty/isEmptyArray';

import * as exElement from '../../utils/element';
import { activate, data, next as nextStep, previous as previousStep } from './utils';

// ----------------------------------------------------------------------------

function create(config: IStepperConfig = {}): IStepperBuild {
    // Default Config
    const defConfig: IStepperConfig = {
        tag: 'ol',
        class: {
            new: 'stepper',
        },
    };

    // Merge
    merge(defConfig, config);

    // ------------------------------------------------------------------------

    //
    const builds = {
        element: {},
    } as IStepperBuild;

    // ------------------------------------------------------------------------

    // Create element (stepper)
    const elStepper = exElement.create({
        merge: defConfig,
    });
    builds.element = elStepper;

    // ------------------------------------------------------------------------

    // Settings
    settings(builds, defConfig);

    // Methods
    methods(builds);

    // ------------------------------------------------------------------------

    // Return
    return builds;
}

function settings(builds: IStepperBuild, config: IStepperConfig = {}): void {
    // If using data
    if (!isEmptyArray(config.data)) {
        builds.items = data(builds.element, config);
    }
}

function methods(builds: IStepperBuild): void {
    builds.previous = function (): ReturnType<typeof previousStep> {
        return previousStep(builds.element, builds.items);
    };

    builds.next = function (): ReturnType<typeof nextStep> {
        return nextStep(builds.element, builds.items);
    };
}

// ----------------------------------------------------------------------------

export { create };
